import { render, staticRenderFns } from "./fileUpload.vue?vue&type=template&id=0386e9c8&"
import script from "./fileUpload.vue?vue&type=script&lang=js&"
export * from "./fileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports